import produce from 'immer'
import { createAsyncObject } from '@jarvis.oddle/core/tools/redux/action'
import {
  updateForAsyncRequest,
  updateForAsyncSuccess,
  updateForAsyncFailure,
  updateForOptimisticBackup,
  updateForOptimisticSuccess
} from '@jarvis.oddle/core/tools/redux/reducer'
import { appendSelectedItems } from '@jarvis.oddle/core/tools/promotion'
import * as CC from 'redux-store/common/constants'
import * as C from './constants'

export const initialState = {
  storeOrder: createAsyncObject({}),
  eligiblePromotions: createAsyncObject({}), // previously checkoutPromotions
  selectedPromotions: createAsyncObject([]),
  availableTimeSlots: createAsyncObject([]) // previously slots
}

export const reducers = (state = initialState, action) => produce(state, draftState => {
  switch (action.type) {
    case CC.CHANGE_CART_NAME:
      draftState.storeOrder.fetched = false
      draftState.eligiblePromotions.fetched = false
      draftState.availableTimeSlots.fetched = false
      break
    case C.GET_STORE_ORDER_REQUEST: updateForAsyncRequest(draftState.storeOrder); break
    case C.GET_STORE_ORDER_SUCCESS:
      const { storeOrder } = action.payload
      updateForAsyncSuccess(storeOrder)(draftState.storeOrder)
      break
    case C.GET_STORE_ORDER_FAILURE: updateForAsyncFailure(action)(draftState.storeOrder); break
    /* CHECKOUT PROMOTIONS - START */
    case C.GET_ELIGIBLE_PROMO_REQUEST: updateForAsyncRequest(draftState.eligiblePromotions); break
    case C.GET_ELIGIBLE_PROMO_SUCCESS:
      updateForAsyncSuccess(action.payload)(draftState.eligiblePromotions)
      draftState.selectedPromotions.data = appendSelectedItems(
        draftState.eligiblePromotions.data.promotions,
        draftState.storeOrder.data.orderPromotions,
        draftState.storeOrder.data.orderItems
      ).concat(appendSelectedItems(
        draftState.eligiblePromotions.data.promoCodePromotions,
        draftState.storeOrder.data.orderPromotions,
        draftState.storeOrder.data.orderItems
      ))
      break
    case C.GET_ELIGIBLE_PROMO_FAILURE: updateForAsyncFailure(action)(draftState.eligiblePromotions); break
    case C.APPLY_PROMO_CODE_REQUEST:
    case C.APPLY_PROMOTIONS_REQUEST: updateForAsyncRequest(draftState.selectedPromotions); break
    case C.APPLY_PROMO_CODE_SUCCESS: updateForAsyncSuccess()(draftState.selectedPromotions); break
    case C.APPLY_PROMOTIONS_SUCCESS:
      draftState.storeOrder.data = action.payload.storeOrder
      updateForAsyncSuccess()(draftState.selectedPromotions)
      break
    case C.APPLY_PROMO_CODE_FAILURE:
    case C.APPLY_PROMOTIONS_FAILURE: updateForAsyncFailure(action)(draftState.selectedPromotions); break
    case C.TOGGLE_PROMOTION: {
      const promotion = action.payload.promotion
      const idx = draftState.selectedPromotions.data.findIndex((p) => p.id === promotion.id)
      if (idx < 0) {
        if (promotion.isPromoCodePromotion && promotion.stackableOption) {
          draftState.selectedPromotions.data = draftState.selectedPromotions.data.filter((p) => p.isPromoCodePromotion)
        }
        draftState.selectedPromotions.data.push(promotion)
      } else {
        draftState.selectedPromotions.data.splice(idx, 1)
      }
      break
    }
    /* CHECKOUT PROMOTION - END */
    case C.UPDATE_STORE_ORDER_ITEM_QUANTITY_REQUEST: updateForAsyncRequest(draftState.storeOrder); break
    case C.UPDATE_STORE_ORDER_ITEM_QUANTITY_OPTIMISTIC_SUCCESS: updateForOptimisticSuccess({ ...draftState.storeOrder.data, orderItems: action.payload.items })(draftState.storeOrder); break
    case C.UPDATE_STORE_ORDER_ITEM_QUANTITY_OPTIMISTIC_BACKUP: updateForOptimisticBackup(action.payload.storeOrder)(draftState.storeOrder); break
    case C.UPDATE_STORE_ORDER_ITEM_QUANTITY_SUCCESS:updateForAsyncSuccess(action.payload.storeOrder)(draftState.storeOrder); break
    case C.UPDATE_STORE_ORDER_ITEM_QUANTITY_FAILURE: updateForAsyncFailure(action)(draftState.storeOrder); break
    case C.ADD_TO_CART_REQUEST: updateForAsyncRequest(draftState.storeOrder); break
    case C.ADD_TO_CART_SUCCESS: updateForAsyncSuccess(action.payload.storeOrder)(draftState.storeOrder); break
    case C.ADD_TO_CART_FAILURE: updateForAsyncFailure(action)(draftState.storeOrder); break
    case C.CLEAR_CART_REQUEST: updateForAsyncRequest(draftState.storeOrder); break
    case C.CLEAR_CART_SUCCESS: updateForAsyncSuccess(action.payload.storeOrder)(draftState.storeOrder); break
    case C.CLEAR_CART_FAILURE: updateForAsyncFailure(action)(draftState.storeOrder); break
    case C.GET_TIME_SLOTS_REQUEST: updateForAsyncRequest(draftState.availableTimeSlots); break
    case C.GET_TIME_SLOTS_SUCCESS: updateForAsyncSuccess(action.payload.timeIntervals)(draftState.availableTimeSlots); break
    case C.GET_TIME_SLOTS_FAILURE: updateForAsyncFailure(action)(draftState.availableTimeSlots); break
    case C.SYNC_METHOD_REQUEST: updateForAsyncRequest(draftState.storeOrder); break
    case C.SYNC_METHOD_SUCCESS: updateForAsyncSuccess(action.payload.storeOrder)(draftState.storeOrder); break
    case C.SYNC_METHOD_FAILURE: updateForAsyncFailure(action)(draftState.storeOrder); break
    case C.SYNC_PICKUP_LOCATION_REQUEST:
      updateForAsyncRequest(draftState.storeOrder)
      draftState.storeOrder.data.storeId = action[1]
      break
    case C.SYNC_PICKUP_LOCATION_SUCCESS: updateForAsyncSuccess(action.payload.storeOrder)(draftState.storeOrder); break
    case C.SYNC_PICKUP_LOCATION_FAILURE: updateForAsyncFailure(action)(draftState.storeOrder); break
    case C.SYNC_DELIVERY_LOCATION_REQUEST: updateForAsyncRequest(draftState.storeOrder); break
    case C.SYNC_DELIVERY_LOCATION_SUCCESS: updateForAsyncSuccess(action.payload.storeOrder)(draftState.storeOrder); break
    case C.SYNC_DELIVERY_LOCATION_FAILURE: updateForAsyncFailure(action)(draftState.storeOrder); break
    case C.SYNC_DELIVERY_ADDRESS_TWO_REQUEST: updateForAsyncRequest(draftState.storeOrder); break
    case C.SYNC_DELIVERY_ADDRESS_TWO_SUCCESS:
      updateForAsyncSuccess((storeOrder) => {
        storeOrder.data = {
          ...storeOrder.data,
          deliveryAddress: action.payload.data.address,
          deliveryAddressTwo: action.payload.data.addressTwo
        }
      })(draftState.storeOrder)
      break
    case C.SYNC_DELIVERY_ADDRESS_TWO_FAILURE: updateForAsyncFailure(action)(draftState.storeOrder); break
    case C.SYNC_COLLECTION_TIME_SUCCESS: draftState.storeOrder.data = action.payload.storeOrder; break
    case C.PREPARE_CHECKOUT_REQUEST: updateForAsyncRequest(draftState.storeOrder); break
    case C.PREPARE_CHECKOUT_SUCCESS:
      if (action.payload.ok) {
        updateForAsyncSuccess(action.payload.storeOrder)(draftState.storeOrder)
      } else {
        updateForAsyncFailure(action)(draftState.storeOrder)
        draftState.storeOrder.data = action.error.storeOrder
        draftState.storeOrder.data.errors = action.error.errors
      }
      break
    case C.PREPARE_CHECKOUT_FAILURE: updateForAsyncFailure(action)(draftState.storeOrder); break
    case C.RESET_APPOINTMENT_ACTION:
      draftState.storeOrder.data.collectionDate = null
      draftState.storeOrder.data.collectionTime = null
      draftState.storeOrder.data.deliveryAddress = null
      draftState.storeOrder.data.storeAddress = null
      break
  }
})
